<template>
  <div class="room-item">
    <div class="room-header">
      <div class="room-left">
        <img src="@/assets/images/bene-log.png" alt="demo" />
        <div class="services-offer">
          <div class="item">
            <i class="icon icon-bor-food" />
            <span>朝食のみ</span>
          </div>
        </div>
      </div>
      <div class="room-right">
        <div v-for="(item, index) in tagsText" :key="index">
         <Tag :text="`${item}`" class="mr-2"/>
        </div>
      </div>
    </div>
    <div class="room-body">
      <div class="room-title">
        <div class="flex items-start">
          <div class="label label-primary mt-2 mr-4">NEW</div>
          <h3>
            <a href="#">
              {{nameRoom}}
            </a>
          </h3>
        </div>
      </div>
      <div class="room-label-mobile">
        <div v-for="(item, index) in tagsText" :key="index">
         <Tag :text="`${item}`" class="mr-2"/>
        </div>
      </div>
      <div class="room-price">
        <span>大人1人／1泊の料金</span>
        <strong>15,000円～</strong>
      </div>
    </div>
    <div class="room-footer">
      <a-button size="large" @click="$router.push('bs-pnl-02-001')">詳細を見る</a-button>
      <a-tooltip :overlayClassName="randomInt == 0 ? 'tooltip-red' : 'tooltip-blue'">
        <template slot="title">
          {{randomInt == 0 ? '残りわずか' : '空室あり'}}
        </template>
        <a-button class="btn-dark ml-4" size="large" @click="$router.push('bs-pnl-02-001')">予約する</a-button>
      </a-tooltip>
    </div>
  </div>
</template>

<script>
import Tag from '../../primitive/Tag'

export default {
  components: {
    Tag
  },
  props: {
    nameRoom: String,
    tags: Array
  },
  data() {
    return {
      tagsText: [
        '現地決済予約',
        '事前決済予約',
        'カフェポイント',
        'すくすくえいど',
        '介護補助'
      ]
    }
  },
  mounted() {
    if (this.tags) {
      this.tagsText = this.tags
    }
  },
  computed: {
    randomInt() {
      return Math.floor(Math.random() * 2)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
/deep/ .ant-btn-lg {
  font-weight: 700;
  color: #1F2021;
}
/deep/ .btn-dark {
  background-color: #434547;
  color: #ffffff;
}
</style>
<style lang="scss">
.tooltip-red .ant-tooltip-inner {
  background-color: #DA291C;
  color: #ffffff;
}
.tooltip-blue .ant-tooltip-inner {
  background-color: #259BEE;
  color: #ffffff;
}
</style>